import { Component } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-incentive-performance',
  standalone: true,
  imports: [MaterialModule, TablerIconsModule],
  templateUrl: './incentive-performance.component.html',
})
export class IncentivePerformanceComponent {
  constructor() {}
}
